module.exports = __webpack_public_path__ + "static/media/twitter.a57ea219.svg";